<template>
  <Modal v-model="openFlowForm" title="发起流程" footer-hide width="400" height="400" :mask-closable="false"
    :closable="false">
    <Form ref="flowItem" :model="flowItem" :rules="ruleValidate" :label-width="80">
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="流水号" prop="title">
          <Input v-model="flowItem.title" readonly></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="流程名称" prop="flowId">
          <Select @on-select="selectFlow" v-model="flowItem.flowId" style="width: 100%">
            <Option :value="x.id" v-for="(x, index) in flowList" :key="index" :label="x.name">
              <span>{{ x.name }}</span>
            </Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="24" v-if="false">
        <FormItem label="备注内容" prop="content">
          <Input v-model="flowItem.content" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="下个节点" prop="nextNodeName">
          <Input v-model="flowItem.nextNodeName" readonly></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="待办人" prop="auditorUser1">
          <Input v-model="flowItem.auditorUser1" readonly></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="图片" prop="beforeImgList">
          <ly-photo ref="lyphoto" v-model="flowItem.beforeImgList"></ly-photo>
        </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <Col span="24">
        <div class="btn-wrap">
          <Button @click="noCreated">不发流程</Button>
          <Button type="primary" @click="createdFlow('flowItem')">发起流程</Button>
        </div>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>
<script>
export default {
  props:['tag'],
  data() {
    return {
      openFlowForm: false,
      flowItem: {
        groupId: "1",
        flowId: "",
        title: "",
        docId: "",
        formId: "",
        auditorUserid: [],
        auditorUser: [],
        content: "流程发起",
        beforeImg: "",
        beforeImgList: [],
        afterImg: "",
        filePath: "",
        nextNodeName: "", //前端看的，不需要传后台
      },
      flowList: [],
      ruleValidate: {
        title: { required: true, message: "必填" },
        flowId: { required: true, message: "必填" },
        content: { required: true, message: "必填" },
      },
    };
  },
  methods: {
    reach(v) {
      this.openFlowForm = true;
      this.flowItem.title = v.no;
      this.flowItem.docId = v.id;
      this.flowItem.groupId = v.groupId;
      this.flowItem.flowId = v.flowId;
      this.flowItem.formId = v.formId;
      this.getFlowList();

      //this.getNextNode({value:v.flowId});
    },
    //创建流程

    createdFlow(name) {
      this.flowItem.beforeImg = this.flowItem.beforeImgList.join(",");
      console.log(this.flowItem);
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            url: this.axios.flow + "/flow/newFlowProcess",
            data: this.flowItem,
          }).then((res) => {
            this.$Spin.hide(); //关闭加载
            if (res) {
              this.openFlowForm = false;
              this.$emit("ok", true);
            }
          });
        }
      });
    },
    getFlowList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.flowList=[];
        for (let i = 0; i < data.length; i++) {
          //console.log(data[i].tag.includes("付款申请"));
          var obj = {
            id: data[i].id,
            name: data[i].name
          }

          if (data[i].tag.includes(this.tag)) {
            this.flowList.push(obj)
          }

        }
        console.log(this.flowList);
      });
    },
    getNextNode(row) {
      ///cloud-common-server-flow/flow/nextNode
      this.utils.loading(this, "加载中");
      var can = {
        flowId: row.value,
        nodeId: "T001",
        nodeType: 1, //0-开始节点(新建时指定),1-中间节点,2-结束节点
      };
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/nextNode",
        data: can,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        this.flowItem.nextNodeName = data.name;
        this.flowItem.auditorUserid = [];
        this.flowItem.auditorUser = [];
        console.log(data);
        for (const i in data.user) {
          this.flowItem.auditorUserid.push(data.user[i].accountId);
          this.flowItem.auditorUser.push(data.user[i].name);
        }
        this.flowItem.auditorUser1 = this.flowItem.auditorUser.join("/");
      });
    },
    selectFlow(v) {
      this.getNextNode(v);
    },
    noCreated() {
      this.openFlowForm = false;

    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/createdFlow.vue